export const actionType = {
  showNotify: "showNotify", // 通知
  hideNotify: "hideNotify",
  showDialog: "showDialog", // 弹框
  hideDialog: "hideDialog",
  showToast: "showToast", // 轻提示
  hideToast: "hideToast",
  showLoading: "showLoading",
  hideLoading: "hideLoading",
  shareGoods: "shareGoods", // 分享（安卓方法）
  pop: "pop", // 返回上一级路由
  routerPush: "routerPush", // 路由
  picturePreview: "picturePreview", // 预览图片
  downloadImage: "downloadImage",//下载图片
  backHome: "backHome", // 返回首页
  backUser: "backUser", //返回用户中心
  openAlbum: "openAlbum", // 打开相册
  makePhoneCall: "makePhoneCall", //安卓打电话
  clickCopy: "clickCopy", //复制文本
  gotoPay: "gotoPay", //跳转信用卡支付
  shareShop: "shareShop", //分享小店
  exitapp: "exitapp", //退出APP
  initApprate: "initApprate",//APP评分
  //极光推送
  setAlias: "setAlias",
  onClearBadge: "onClearBadge",
  initJpush: "initJpush",
  refresh: "refresh",//刷新页面
};
//this.$commonEnv.actionType
//method-type
//methodType
